import React from "react";

import Box from "@/components/shared/Box";

import type { PuppiesSectionProps } from "./puppiesSection.types";

import s from "./puppiesSection.module.scss";

const PuppiesSection = ({
  name,
  filhoteImage,
  filhoteDescription
}: PuppiesSectionProps) => {
  return (
    <div className={s.wrapper}>
      <h2 className={`heading-sm ${s.heading}`}>Filhotes de {name}</h2>
      <Box
        padding={"var(--token-spacings-xxs)"}
        border={"1px solid var(--token-colors-neutral-cloud-normal)"}
        borderRadius={"var(--token-border-radius-lg)"}
      >
        <div className={s.content}>
          <div
            className="body-text-sm"
            dangerouslySetInnerHTML={{ __html: filhoteDescription }}
          />
          {filhoteImage && (
            <div>
              <img
                src={filhoteImage}
                alt={`Imagem do filhote de ${name}`}
                width={252}
                height={252}
              />
            </div>
          )}
        </div>
      </Box>
    </div>
  );
};

export default PuppiesSection;
